<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="consideration-support-modal"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head01">
      <h1 id="consideration-support-modal" class="p-modal-head01__title">
        <span [innerHTML]="'label.support' | staticMsg"></span>
      </h1>
      <button class="p-modal-head01__close js-modal-close" (click)="closeModalEvent()" id="support-btn-close">
        <span class="u-visually-hidden" [innerHTML]="'label.support' | staticMsg"></span>
      </button>
    </div>
  </div>
  <div #modalBody [class]="lmodalBodyClass">
    <ng-container *ngFor="let traveler of supportPassengerInforList">
      <div class="p-modal-body06">
        <div class="p-mybooking-support">
          <div class="p-mybooking-support__item">
            <div class="p-mybooking-support__title p-mybooking-support__title--em">
              {{ getTravelerName(traveler) }}
              <div
                class="c-plan-table01__col-item c-plan-table01__col-item--gray60"
                *ngIf="isAccompanyingTravelerForSpecialBaggage(traveler)"
                [innerHTML]="getAccompanyingTraveler(traveler)"
              ></div>
            </div>
            <div
              class="p-mybooking-support__contents"
              *ngIf="getSpecialServiceRequest(traveler.id).length > 0; else noSpecialServiceRequest"
            >
              <ng-container *ngFor="let specialServiceRequest of getSpecialServiceRequest(traveler.id)">
                <p>
                  <span>{{ considerationSupportContent(specialServiceRequest) }}<br /></span>
                  <span
                    *ngIf="
                      getConsiderationSupportInforRegistrationStatus(specialServiceRequest);
                      let considerationSupportInforRegistrationStatus
                    "
                    [innerHTML]="considerationSupportInforRegistrationStatus | staticMsg"
                    ><br
                  /></span>
                </p>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<ng-template #noSpecialServiceRequest>
  <!-- 提携：「申し込まれていません」に対する文言ID割り当て　 -->
  <div class="p-mybooking-support__contents"><span [innerHTML]="'label.notRegistered' | staticMsg"></span></div>
</ng-template>
